import { apiURL } from "../redux/api";

/**
 * Resolve a file URL from the database.
 * CDN files are stored as full URLs (https://...).
 * Local files are stored as relative paths (/uploads/filename).
 * Legacy files are stored as just the filename.
 */
export function getFileUrl(imageUrl) {
  if (!imageUrl) return "";
  if (imageUrl.startsWith("http://") || imageUrl.startsWith("https://")) {
    return imageUrl;
  }
  if (imageUrl.startsWith("/")) {
    return `${apiURL}${imageUrl}`;
  }
  return `${apiURL}/uploads/${imageUrl}`;
}
